var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopGraphics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.4284 15.7961C79.7816 16.1408 80.0001 16.617 80.0001 17.1427C80.0001 17.6685 79.7816 18.1446 79.4284 18.4894C79.075 18.8342 78.5872 19.0475 78.0489 19.0475C76.9718 19.0475 76.0977 18.1942 76.0977 17.1427C76.0977 16.617 76.3162 16.1408 76.6694 15.7961C77.0227 15.4513 77.5105 15.238 78.0489 15.238C78.5872 15.238 79.075 15.4513 79.4284 15.7961Z",
    fill: "#94D4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6235 72.9393C71.9766 73.2842 72.1952 73.7604 72.1952 74.2859C72.1952 74.8115 71.9766 75.2878 71.6235 75.6326C71.2701 75.9774 70.7823 76.1907 70.2439 76.1907C69.1669 76.1907 68.2927 75.3374 68.2927 74.2859C68.2927 73.7602 68.5113 73.284 68.8644 72.9393C69.2178 72.5945 69.7056 72.3812 70.2439 72.3812C70.7823 72.3812 71.2701 72.5945 71.6235 72.9393Z",
    fill: "#94D4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3173 0C70.0119 0 72.1953 2.13143 72.1953 4.76191C72.1953 7.39238 70.0119 9.52381 67.3173 9.52381C64.6226 9.52381 62.4392 7.39238 62.4392 4.76191C62.4392 2.13143 64.6226 0 67.3173 0Z",
    fill: "#F88F19"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6097 74.2858C57.2253 74.2858 58.5365 75.5658 58.5365 77.143C58.5365 78.7201 57.2253 80.0001 55.6097 80.0001C53.9941 80.0001 52.6829 78.7201 52.6829 77.143C52.6829 75.5658 53.9939 74.2858 55.6097 74.2858Z",
    fill: "#F88F19"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1113 4.54082C52.4644 4.88558 52.683 5.36177 52.683 5.88749C52.683 6.4132 52.4644 6.88939 52.1113 7.23416C51.7579 7.57892 51.2701 7.79225 50.7317 7.79225C49.6547 7.79225 48.7805 6.93892 48.7805 5.88749C48.7805 5.36177 48.9991 4.88558 49.3522 4.54082C49.7056 4.19606 50.1934 3.98273 50.7317 3.98273C51.2701 3.98273 51.7579 4.19606 52.1113 4.54082Z",
    fill: "#94D4FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3551 76.7482C42.7083 77.0932 42.9269 77.5694 42.9269 78.0949C42.9269 78.6204 42.7083 79.0968 42.3551 79.4416C42.0018 79.7863 41.514 79.9996 40.9756 79.9996C39.8986 79.9996 39.0244 79.1463 39.0244 78.0949C39.0244 77.5692 39.2429 77.093 39.5961 76.7482C39.9495 76.4035 40.4373 76.1901 40.9756 76.1901C41.514 76.1901 42.0018 76.4035 42.3551 76.7482Z",
    fill: "#94D4FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6965 2.4627C29.0499 2.80746 29.2684 3.28365 29.2684 3.80936C29.2684 4.33508 29.0499 4.81127 28.6965 5.15603C28.3433 5.50079 27.8555 5.71413 27.3172 5.71413C26.2399 5.71413 25.366 4.86079 25.366 3.80936C25.366 3.28365 25.5845 2.80746 25.9377 2.4627C26.291 2.11794 26.7788 1.9046 27.3172 1.9046C27.8555 1.9046 28.3433 2.11794 28.6965 2.4627Z",
    fill: "#94D4FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7562 3.80988C11.9123 3.80988 13.6586 5.51464 13.6586 7.6194C13.6586 9.72416 11.9123 11.4289 9.7562 11.4289C7.6001 11.4289 5.85376 9.72416 5.85376 7.6194C5.85376 5.51464 7.6001 3.80988 9.7562 3.80988Z",
    fill: "#F88F19"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33054 71.0344C3.6839 71.3793 3.90244 71.8555 3.90244 72.381C3.90244 72.9065 3.6839 73.3829 3.33054 73.7277C2.97737 74.0724 2.48956 74.2858 1.95122 74.2858C0.873951 74.2858 0 73.4324 0 72.381C0 71.8553 0.218537 71.3791 0.571707 71.0344C0.925073 70.6896 1.41288 70.4763 1.95122 70.4763C2.48956 70.4763 2.97737 70.6896 3.33054 71.0344Z",
    fill: "#94D4FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4603 49.4741H7.53442V28.4519C7.53442 27.3111 8.18628 26.3333 9.00109 25.6815L35.89 8.73333C37.5196 7.75556 39.4752 7.75556 41.1048 8.73333L67.9937 25.6815C68.9715 26.3333 69.4603 27.3111 69.4603 28.4519V49.4741Z",
    fill: "#71A5D3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.312 53.5482H15.6824V24.2149C15.6824 23.2371 16.3342 22.5853 17.312 22.5853H59.6824C60.6601 22.5853 61.312 23.2371 61.312 24.2149V53.5482Z",
    fill: "url(#paint0_linear_2158_22782)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4601 29.1038V63.8149C69.4601 65.4446 68.1564 66.5853 66.5268 66.5853H15.0305L22.8527 56.3186L69.4601 29.1038Z",
    fill: "url(#paint1_linear_2158_22782)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53442 29.1038V63.8149C7.53442 65.4446 8.83813 66.5853 10.4678 66.5853H66.69C67.6678 66.5853 68.4826 66.0964 68.9715 65.4446L7.53442 29.1038Z",
    fill: "url(#paint2_linear_2158_22782)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8889 62.6665C72.8889 67.575 68.9084 71.5554 64 71.5554C59.0915 71.5554 55.1111 67.575 55.1111 62.6665C55.1111 57.7581 59.0915 53.7776 64 53.7776C68.9084 53.7776 72.8889 57.7581 72.8889 62.6665Z",
    fill: "url(#paint3_linear_2158_22782)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7964 66.5369L59.2408 62.9813C59.0675 62.808 59.0675 62.5262 59.2408 62.3529L59.8693 61.7244C60.0426 61.5511 60.3244 61.5511 60.4977 61.7244L63.1111 64.3369L67.9457 59.5022C68.1191 59.3289 68.4008 59.3289 68.5742 59.5022L69.2026 60.1306C69.376 60.304 69.376 60.5857 69.2026 60.7591L63.4248 66.5369C63.2515 66.7102 62.9706 66.7102 62.7964 66.5369Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2158_22782",
    x1: 38.4972,
    y1: 23.2632,
    x2: 38.4972,
    y2: 45.7798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F8F8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E3E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2158_22782",
    x1: 41.5707,
    y1: 46.9255,
    x2: 61.3071,
    y2: 75.1718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FA0E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2158_22782",
    x1: 4.39576,
    y1: 45.7847,
    x2: 64.5095,
    y2: 74.9372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28AFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B88DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2158_22782",
    x1: 57.7146,
    y1: 56.3812,
    x2: 70.2853,
    y2: 68.9519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21AD64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088242"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopGraphics);
export default __webpack_public_path__ + "static/media/envelop-graphics.ec7ccae01b04ff664ecab119691b0c68.svg";
export { ForwardRef as ReactComponent };